import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "../api/projectDetails";

export const useFetchProjectActivityList = (projectId?: string) => {
    const { data, isFetching, isSuccess, isPending, isError, error, refetch } = useQuery({
        queryKey: ["project-activity-list", projectId],
        queryFn: () => projectDetailsApi.fetchProjectActivityList(projectId),
        enabled: !!projectId,
    });

    return {
        data: isSuccess ? (data?.data?.rows ?? data?.rows ?? []) : [],
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };
};
